import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
    recentArticlesSection: {
        width: '100%',
        marginBottom: 36,
        [theme.breakpoints.only('md')]: {
            '& > div > div:nth-child(n+7)': {
                display: 'none'
            }
        },
        [theme.breakpoints.down('sm')]: {
            '& > div > div:nth-child(n+5)': {
                display: 'none'
            }
        }
    },
    showMoreButtonBox: {
        display: 'flex',
        justifyContent: 'center'
    }
}))
